import React, {useCallback, useRef, useState} from "react";
import {FlatList, NativeScrollEvent, NativeSyntheticEvent} from "react-native";
import P from "../lib/P";
import {colors} from "../assets/styles/colors";
import Div from "../lib/Div";
import MainStyle from "../../MainStyle";
import moment from "moment";
import TournamentHeader from "./TournamentHeader";
import {isFullSwing} from "../constants";
import Btn from "./Btn";
import {
  Tournament, TournamentPlayerBet_State, TournamentPlayerDetails_State, TournamentPrizeDistributionItem
} from "../../generated/smg_service_pb";
import {tournamentStatusStyle} from "../utils";
import {useRoute} from "@react-navigation/native";
import PrizePool from "./PrizePool";
import RegisteredPlayersStatus from "./RegisteredPlayersStatus";

const ITEM_WEIGHT = 387;

type Props = {
  tournament?: Tournament, getUser: () => void, getTournament: () => void, level?: number | string,
  goBack: () => void, prizeDistribution?: TournamentPrizeDistributionItem[]
};

const TournamentCard = (props: Props) => {
  const {tournament, level, prizeDistribution} = props;
  const statusStyle = tournamentStatusStyle(tournament?.state);
  const registered = !!tournament?.currentPlayerDetails && tournament.currentPlayerDetails.state !== TournamentPlayerDetails_State.FINISHED;
  const route = useRoute();
  const params: any = route?.params;
  const isPrivateTournament = typeof params?.isPrivateTournament === 'string' ? params?.isPrivateTournament === 'true' : !!params?.isPrivateTournament;
  const showPopup = typeof params?.showPopup === 'string' ? params?.showPopup === 'true' : !!params?.showPopup;
  const [activeTab, setActiveTab] = useState(1);
  const flatListRef = useRef<FlatList<number>>(null);
  const currentNumberOfShots = tournament?.currentPlayerDetails?.bets.filter(bet => bet.state === TournamentPlayerBet_State.FINISHED && bet.resolved).length || 0;

  const getItemLayout = (data: any, index: number) => (
    {length: ITEM_WEIGHT, offset: ITEM_WEIGHT * index, index}
  );

  const onScroll = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const slideSize = event.nativeEvent.layoutMeasurement.width;
    setActiveTab(Math.ceil((event.nativeEvent.contentOffset.x + slideSize / 2) / 378));
  }, []);

  const renderItem = ({item}: any) => {
    if (!tournament) return <></>;
    else {
      return (
        <Div>
          {!isFullSwing && (
            <>
              <Div row>
                <Div flex={1} h={4} bg={item !== 1 ? 'transparent' : isFullSwing ? '#3369FF' : colors.filter_chip_bg}/>
                <Div flex={1} h={4} bg={item !== 2 ? 'transparent' : isFullSwing ? '#3369FF' : colors.filter_chip_bg}/>
              </Div>

              <Div h={1} mb={14} bg={colors.darkText}/>
            </>
          )}

          {item === 1 ? (
            <PrizePool
              w={ITEM_WEIGHT} maxH={248} b_b_r={0} state={tournament.state} prizePoolList={tournament.prizePool}
              playerDetailsList={tournament.playerDetails} prizeDistribution={prizeDistribution}
              guaranteedPricePool={tournament.minimumGuaranteedPricePool} entryfee={tournament.entryFee}
            />
          ) : (
            <RegisteredPlayersStatus
              w={ITEM_WEIGHT} maxH={248} b_b_r={0} item={tournament?.playerDetails}
              playerId={tournament.currentPlayerDetails?.playerId}
              guaranteedPricePool={tournament.minimumGuaranteedPricePool}
            />
          )}
        </Div>
      );
    }
  };

  const scrollToItem = (index: number) => {
    flatListRef.current?.scrollToIndex({animated: true, index: index});
  };

  return (
    <>
      {tournament && (
        <>
          {isFullSwing ? (
            <>
              <Div row mx={20}>
                <P fontFamily="DavisSans-Medium" fs={isFullSwing ? 18 : 17} flex={1} numberOfLines={2} mx={5}>
                  {tournament.name}
                </P>
                <P w={82} lh={36} ta="center" bw={1} ml={13} fw="700" fs={14} tt="uppercase"
                   borderColor={statusStyle.color}>
                  {statusStyle.text}
                </P>
              </Div>

              <Div h={1} bg="#676767" my={16} mx={20}/>
            </>
          ) : (
            <>
              <P ta="center" fw="500" fs={24} mb={7} numberOfLines={1}>{tournament.name}</P>
              <P color={colors.id_text} ta="center" fw="500" fs={20} lh={20} mb={5}>#{tournament.id}</P>

              <Div w={60} h={60} rounded={30} bg="#3369FF" pt={14} mx="auto" mb={8}>
                <P fontFamily="DavisSans-Medium" fs={14} lh={14} ta="center" tt="uppercase">Level</P>
                <P fontFamily="DavisSans-Medium" fs={24} lh={24} ta="center">{level}</P>
              </Div>
            </>
          )}

          {isFullSwing ? (
            <Div row justifyContent="space-between" mx={25} mb={27}>
              <Div>
                <P fontFamily="DavisSans-Medium" fs={10} tt="uppercase">TOURNEY ID</P>
                <P fontFamily="DavisSans-Medium" fs={14}>{tournament.id}</P>
              </Div>

              <Div>
                <P fontFamily="DavisSans-Medium" fs={10} tt="uppercase">Start</P>
                <P fontFamily="DavisSans-Medium" fs={13}>
                  {moment.unix(Number(tournament.entryBeginDate)).format('ddd, MMM DD, yyyy')}
                </P>
                <P fontFamily="DavisSans-Medium" fs={13}>
                  {moment.unix(Number(tournament.entryBeginDate)).format('hh:mm A')}
                </P>
              </Div>

              <Div>
                <P fontFamily="DavisSans-Medium" fs={10} tt="uppercase">End</P>
                <P fontFamily="DavisSans-Medium" fs={13}>
                  {moment.unix(Number(tournament.entryEndDate)).format('ddd, MMM DD, yyyy')}
                </P>
                <P fontFamily="DavisSans-Medium" fs={13}>
                  {moment.unix(Number(tournament.entryEndDate)).format('hh:mm A')}
                </P>
              </Div>
            </Div>
          ) : (
            <Div mx="auto" w={367}>
              <Div row mx={12} alignItems="center" mb={12}>
                <Div column flex={1}>
                  <Div row mb={3} justifyContent="space-between">
                    <P fw="500" fs={14} lh={17} tt="uppercase">Start</P>
                    <P fw="600" lh={17}>{moment.unix(Number(tournament.entryBeginDate)).format('llll')}</P>
                  </Div>

                  <Div row justifyContent="space-between">
                    <P fw="500" fs={14} lh={17} tt="uppercase">End</P>
                    <P fw="600" lh={17}>{moment.unix(Number(tournament.entryEndDate)).format('llll')}</P>
                  </Div>
                </Div>

                <P w={82} lh={36} ta="center" bw={1} ml={13} fw="700" fs={14} tt="uppercase"
                   borderColor={statusStyle.color}>
                  {statusStyle.text}
                </P>
              </Div>
            </Div>
          )}

          {(!registered && !isFullSwing) && (
            <TournamentHeader
              mb={24} item={tournament} onReload={props.getUser} isPrivateTournament={isPrivateTournament}
              showPopup={showPopup}
            />
          )}

          <Div w={ITEM_WEIGHT} mx="auto">
            <Div row mb={isFullSwing ? -1 : 6}>
              <P color={activeTab === 1 ? 'white' : colors.state_completed} flex={1} ta="center" fw="500"
                 onPress={() => scrollToItem(0)} lh={isFullSwing ? 40 : 24} tt="uppercase"
                 bg={isFullSwing && activeTab === 1 ? '#424242' : 'transparent'} roundedTop={2}>
                Prize Pool
              </P>
              <P color={activeTab === 2 ? 'white' : colors.state_completed} flex={1} ta="center" fw="500"
                 onPress={() => scrollToItem(1)} lh={isFullSwing ? 40 : 24} tt="uppercase"
                 bg={isFullSwing && activeTab === 2 ? '#424242' : 'transparent'} roundedTop={2}>
                {isFullSwing ? 'LEADERBOARD' : `Registered\nPlayers + Status`}
              </P>
            </Div>

            <FlatList
              ref={flatListRef} data={[1, 2]} initialScrollIndex={1} renderItem={renderItem} horizontal
              keyExtractor={(item) => item.toString()} pagingEnabled onScroll={onScroll}
              showsHorizontalScrollIndicator={false} style={MainStyle.m_b_12} getItemLayout={getItemLayout}
            />

            {(registered && !isFullSwing) && (
              <TournamentHeader
                mb={24} item={tournament} onReload={props.getUser} isPrivateTournament={isPrivateTournament}
                showPopup={showPopup}
              />
            )}

            {!isFullSwing && <Div h={1} bg={colors.divider_bg} mb={10}/>}
          </Div>

          {(!isFullSwing && (!isPrivateTournament || (isPrivateTournament && currentNumberOfShots === tournament.totalShots))) && (
            <Btn mb={13} onPress={props.goBack}>
              <P color={isFullSwing ? '#0AF' : colors.newGreenText} fw="700" fs={14} tt="uppercase" ta="center"
                 lh={26}>
                {isPrivateTournament ? 'Back' : '< Back to List'}
              </P>
            </Btn>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(TournamentCard);
